// Both API layers consume exactly the same existing build-time gateway options.
export const gatewayConfig = Object.freeze({
  gatewayDomain: import.meta.env.VITE_GATEWAY_DOMAIN || 'p.xapi.to',
  gatewayMode: import.meta.env.VITE_GATEWAY_MODE || 'auto',
  sandboxDomain: import.meta.env.VITE_SANDBOX_DOMAIN || 'sandbox.xapi.to',
  gatewayLocalPort: import.meta.env.VITE_GATEWAY_PORT || '3001',
  sandboxLocalPort: import.meta.env.VITE_SANDBOX_PORT || '3312',
  wsGatewayLocalPort: import.meta.env.VITE_WS_GATEWAY_PORT || '3011',
});
